import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { AlertConfirmService } from './alert-confirm.service';
import { el } from '@fullcalendar/core/internal-common';

/**
 * @author Hugo Andres Escobar Ciceri
 * @version 2.1.0
 *
 * Alert Component to confirm an action.
 */
@Component({
    selector: 'kanzi-apes-alert-confirm',
    templateUrl: './alert-confirm.component.html',
    styleUrls: ['./alert-confirm.component.scss'],
    providers: [ConfirmationService],
    standalone: false
})
export class AlertConfirmComponent implements OnInit {
  @Output() confirmation = new EventEmitter<
    boolean | { confirm: boolean; keyReturn: string }
  >();
  message: any;
  // isVisible: string;
  // title: string;

  /**
   *
   * @param alertConfirmService {AlertConfirmService} Service to send and receive messages to confirm
   */
  constructor(
    private alertConfirmService: AlertConfirmService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {
    this.alertConfirmService.getMessageConfirm().subscribe((message: any) => {
      if (message && message.text) {
        this.message = message;
        this.confirmationService.confirm({
          message: message ? message.text : '',
          header: message ? message.header : '',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.message = '';
            if (message.keyReturn) {
              this.confirmation.emit({
                confirm: true,
                keyReturn: message.keyReturn,
              });
            } else {
              this.confirmation.emit(true);
            }
          },
          reject: () => {
            this.message = '';
            this.confirmation.emit(false);
          },
        });
      }
    });
  }
}
